import React from 'react';
import { connect } from 'react-redux';

import { Button, SidebarContent } from 'components';
import { forcedSidebar } from 'redux/selectors/app';
import { setSidebar } from 'redux/reducers/app';

// import styles from './styles.scss';

@connect(
  state => ({
    sidebar: forcedSidebar(state),
  }),
  {
    setSidebar,
  }
)
export default class SaveSuccess extends React.PureComponent {
  setSidebar = e => {
    const item = e.currentTarget.dataset.sidebar;
    this.props.setSidebar(item);
  };

  render() {
    const actions = [
      <Button key="werkverder" data-sidebar="child" cta fullWidth onClick={this.setSidebar}>
        {kroostApp.strings.enterTheNameOfChildButton}
      </Button>,
    ];

    return (
      <SidebarContent title={kroostApp.strings.saveSuccessTitle} actions={actions}>
        <p>{kroostApp.strings.saveSuccessMessagePart1}</p>

        <p>{kroostApp.strings.saveSuccessMessagePart2}</p>
      </SidebarContent>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/save-success/index.js